import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { withLDProvider, useFlags } from 'launchdarkly-react-client-sdk';

import registerServiceWorker from './registerServiceWorker';
import { configureStore } from './store/store';
import i18n from './i18n/locale';
import { LD_PROD_KEY, LD_NON_PROD_KEY } from './global-constants';

import App from './containers/App';
import Maintenance from './containers/Maintenance';

const root = document.getElementById('dist-list-ui-app-root');
const initialState = {
	accounts: {},
	allLists: [],
	error: '',
	isFiltering: false,
	selectedList: { id: '', name: '', isFirstLoad: false, distList: [] },
	tree: {},
	treeIsLoaded: false,
	expanded: ['root'],
};

// useFlags() returns {} until the client initializes, so this defaults to
// <App /> on first render, matching the old SDK's initialRenderCallback behavior.
function AppOrMaintenance() {
	const flags = useFlags();
	return flags.distListUiMaintenancePage ? (<Maintenance />) : (<App />);
}

const LDWrappedApp = withLDProvider({
	clientSideID: process.env.NODE_ENV === 'development'
		? LD_NON_PROD_KEY
		: LD_PROD_KEY,
	context: { kind: 'user', key: ddc.global.actualUser.userId },
})(AppOrMaintenance);

if (root == null ) {
	// error
} else {
	ReactDOM.render(
		<Provider store={configureStore(initialState)}>
			<LDWrappedApp />
		</Provider>,
		root
	);
}
registerServiceWorker();
